export { getBasketServerAction } from 'next-flight-server-reference-proxy-loader?id=408d7d2e7a3bf1a4136c3673feacd6d4967937bafb&name=getBasketServerAction!'